import { ref, computed } from 'vue';
import moment from 'moment';

const STORAGE_KEY = 'kit-signup-requested';
const EXPIRY_HOURS = 48; // Hide banner for 48 hours after successful request

const checkIfRequestMade = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return false;
    }

    const { timestamp } = JSON.parse(stored);
    const requestTime = moment(timestamp);
    const expiryTime = requestTime.add(EXPIRY_HOURS, 'hours');

    if (moment().isAfter(expiryTime)) {
      // Expired, remove from storage
      localStorage.removeItem(STORAGE_KEY);
      return false;
    }

    return true;
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY);
    return false;
  }
};

const hasRequestedSignup = ref(checkIfRequestMade());

const markSignupRequested = () => {
  const data = {
    timestamp: moment().toISOString(),
  };
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  hasRequestedSignup.value = true;
};

const clearSignupState = () => {
  localStorage.removeItem(STORAGE_KEY);
  hasRequestedSignup.value = false;
};

export const useKitSignupState = () => {
  return {
    hasRequestedSignup: computed(() => hasRequestedSignup.value),
    shouldShowBanner: computed(() => !hasRequestedSignup.value),
    markSignupRequested,
    clearSignupState,
  };
};
